"use client";

import { useEffect } from "react";

import type { SearchItemsEvent } from "@repo/bi";

import { BiEvent } from "./bi.enum";
import { useTrackEvent, useVisitId } from "./visit-context";

type Props = Pick<SearchItemsEvent, "searchTerm" | "sort" | "items">;

export function TrackSearchItems(props: Props) {
  const track = useTrackEvent();
  const visitId = useVisitId();
  useEffect(() => {
    if (visitId) track(BiEvent.SearchItems, { id: visitId, ...props });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visitId]);
  return null;
}
